import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useSite, waLink } from "../siteContext";
import { useLang } from "../i18n";

export const WhatsAppFloat = () => {
  const settings = useSite();
  const { lang, s } = useLang();
  return (
  <motion.a
    data-testid="whatsapp-float-button"
    href={waLink(settings, undefined, lang)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={s.wa_aria}
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, type: "spring" }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full bg-luxury-gold text-luxury-black flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.35)]"
  >
    <MessageCircle className="w-6 h-6" strokeWidth={1.75} />
  </motion.a>
  );
};
